import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DeliveryNoteTypeView } from '../../monitoring/automotive-aftermarket';
import { LocalDate } from '../../../models';

export class ProofOfDelivery {
  huNumbers: string[] = [];
  content: string = null;
  name: string = null;
  contentType: string = null;
  id?: number;
  documentId?: string = null;

  constructor(params?: Partial<ProofOfDelivery>) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class ProofOfDeliveryDocuments {
  documents: ProofOfDelivery[] = [];
  requestTimestamp?: LocalDate = null;
  id?: number;

  constructor(params?: ProofOfDeliveryDocuments) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class ProofOfDeliveryItem {
  allHandlingUnits: string[] = [];
  proofOfDeliveryView: ProofOfDeliveryDocuments = null;

  constructor(params?: ProofOfDeliveryItem) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class ProofOfDeliveryItemForm {
  id?: FormControl<number>;

  constructor(
    model: ProofOfDeliveryItem,
    fb: FormBuilder = new FormBuilder(),
    public type: FormControl<string> = fb.control<string>(
      { value: DeliveryNoteTypeView.DeliveryNote, disabled: false },
      [Validators.required],
    ),
    public documents: FormArray<FormGroup<ProofOfDeliveryItemFileForm>> = fb.array<
      FormGroup<ProofOfDeliveryItemFileForm>
    >([], []),
  ) {
    if (model?.proofOfDeliveryView?.id) {
      this.id = fb.control<number>(model?.proofOfDeliveryView.id, []);
    }
  }
}

export class ProofOfDeliveryItemFileForm {
  documentId?: FormControl<string>;
  id?: FormControl<number>;

  constructor(
    model: ProofOfDelivery,
    fb: FormBuilder = new FormBuilder(),
    public huNumbers: FormControl<string[]> = fb.control<string[]>(model.huNumbers, [Validators.required]),
    public content: FormControl<string> = fb.control<string>(
      model.content || null,
      model.documentId ? [] : [Validators.required],
    ),
    public name: FormControl<string> = fb.control<string>(model.name),
    public contentType: FormControl<string> = fb.control<string>(model.contentType),
  ) {
    this.documentId = fb.control<string>(model.documentId || null);
    this.id = fb.control<number>(model.id || null);
  }
}
